import { Flex } from '@mantine/core';
import { FC } from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  darkMode?: boolean;
  lowMargin?: boolean;
  hasFooter?: boolean;
}

export const PageContainer: FC<PageContainerProps> = ({
  children,
  darkMode,
  lowMargin,
  hasFooter,
}) => {
  const style = darkMode
    ? {
        height: '100%',
        backgroundColor: 'var(--mantine-color-seriousBlue-0)',
        color: 'var(--mantine-color-clinicalWhite-0)',
      }
    : {
        height: '100%',
        backgroundColor: 'var(--mantine-color-clinicalWhite-0)',
      };

  const paddingTop = lowMargin ? '0' : '24px';

  if (darkMode) {
    document.getElementsByTagName('body')[0].style.backgroundColor =
      'var(--mantine-color-seriousBlue-0)';
  } else {
    document.getElementsByTagName('body')[0].style.backgroundColor =
      'var(--mantine-color-clinicalWhite-0)';
  }

  return (
    <Flex direction={'row'} justify={'center'} style={style}>
      <div
        style={{
          height: '100%',
          maxWidth: '500px',
          width: '100%',
          padding: 'var(--mantine-spacing-md)',
          paddingTop: paddingTop,
          paddingBottom: hasFooter ? '80px' : undefined,
          flexGrow: 1,
        }}
      >
        {children}
      </div>
    </Flex>
  );
};
